/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolToysIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-toys"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.9 20.85Q5.72 20.85 4.83 20.13Q3.92 19.4 3.65 18.25Q2.6 17.65 1.98 16.63Q1.35 15.6 1.35 14.4Q1.35 12.97 2.17 11.81Q3 10.65 4.35 10.15L2.7 8.5L2.55 8.6Q2.17 8.97 1.65 8.95Q1.13 8.93 0.75 8.55Q0.38 8.18 0.35 7.65Q0.33 7.13 0.7 6.75L2.8 4.65Q3.17 4.28 3.7 4.3Q4.22 4.33 4.6 4.7Q4.97 5.08 5 5.6Q5.03 6.13 4.65 6.5L4.55 6.65L5.55 7.65L6.3 5.55Q6.67 4.45 7.6 3.77Q8.53 3.1 9.7 3.1L14.4 3.1Q15.57 3.1 16.51 3.76Q17.45 4.42 17.8 5.55L19.3 10Q20.8 10.38 21.75 11.6Q22.7 12.82 22.7 14.4Q22.7 15.6 22.07 16.63Q21.45 17.65 20.4 18.25Q20.13 19.4 19.21 20.13Q18.3 20.85 17.1 20.85Q16.15 20.85 15.34 20.32Q14.53 19.8 14.05 18.95L10 18.95Q9.53 19.82 8.7 20.34Q7.88 20.85 6.9 20.85ZM7.65 9.85L10.7 9.85L10.7 5.75L9.7 5.75Q9.4 5.75 9.16 5.94Q8.93 6.13 8.8 6.4ZM13.35 9.85L16.45 9.85L15.3 6.4Q15.18 6.13 14.94 5.94Q14.7 5.75 14.4 5.75L13.35 5.75ZM6.92 18.2Q6.92 18.2 7.08 18.2Q7.22 18.2 7.44 17.99Q7.65 17.77 7.65 17.48Q7.65 17.18 7.44 16.96Q7.22 16.75 6.92 16.75Q6.63 16.75 6.41 16.96Q6.2 17.18 6.2 17.48Q6.2 17.77 6.41 17.99Q6.63 18.2 6.92 18.2ZM17.13 18.2Q17.13 18.2 17.27 18.2Q17.43 18.2 17.64 17.99Q17.85 17.77 17.85 17.48Q17.85 17.18 17.64 16.96Q17.43 16.75 17.13 16.75Q16.82 16.75 16.61 16.96Q16.4 17.18 16.4 17.48Q16.4 17.77 16.61 17.99Q16.82 18.2 17.13 18.2Z" fill={color} />
    </svg>
  );
}
